webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueSimpleNotify__ = __webpack_require__(7);

/**
 * A simple Vue component for notifications handling.
 *
 * @author    Josantonius <hello@josantonius.com>
 * @copyright 2018 (c) Josantonius - Vue Simple Notify
 * @license   https://opensource.org/licenses/MIT - The MIT License (MIT)
 * @link      https://github.com/josantonius/vue-simple-notify
 * @since     1.0.0
 */


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'App',
  components: {
    VueSimpleNotify: __WEBPACK_IMPORTED_MODULE_0__components_VueSimpleNotify__["a" /* default */]
  },
  data: function data() {
    return {
      notifications: [{
        message: 'example of error message.'
      }, {
        type: 'Success',
        color: '#2ecc71',
        dismissable: false,
        message: 'example of success message.'
      }, {
        type: 'Warning',
        color: '#e67e22',
        message: 'example of warning message.'
      }, {
        type: 'Info',
        color: '#3498db',
        dismissable: false,
        message: 'example of info message.'
      }, {
        type: 'Custom',
        color: '#9E9E9E',
        dismissable: true,
        message: 'example of custom message.'
      }]
    };
  },

  methods: {
    onDismiss: function onDismiss(index) {
      console.log(index);
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VueSimpleNotify',

  props: {
    /**
     * Notifications array.
     * @default null
     * @type {Array}
     */
    items: {
      type: Array,
      default: null,
      required: true
    },

    /**
     * Time interval between notifications when displayed.
     * @default 500
     * @type {Number}
     */
    delay: {
      type: Number,
      default: 500
    }
  },

  data: function data() {
    return {
      notifications: []
    };
  },


  mounted: function mounted() {
    this.normalizeParams();
    this.display(this);
  },

  methods: {
    /**
     * Normalize parameters by adding optional parameters.
     */
    normalizeParams: function normalizeParams() {
      this.items.map(function (obj, index) {
        obj.index = index;
        obj.dismissable = typeof obj.dismissable !== 'undefined' ? obj.dismissable : true;
        obj.type = typeof obj.type !== 'undefined' ? obj.type : 'Error';
        obj.color = typeof obj.color !== 'undefined' ? obj.color : '#dc3232';
        obj.message = typeof obj.message !== 'undefined' ? obj.message : '';
        return obj;
      });
    },

    /**
     * Normalize parameters by adding optional parameters.
     */
    display: function display(self) {
      this.clear();
      this.items.forEach(function (element, index) {
        setTimeout(function () {
          self.notifications.push(element);
        }, self.delay * index + 1);
      });
    },

    /**
     * Dismiss notification.
     */
    dismiss: function dismiss(index) {
      this.notifications.splice(index, 1);
      this.$emit('onDismiss', index);
    },

    /**
     * Clear all notifications.
     */
    clear: function clear() {
      this.notifications = [];
    }
  },
  watch: {
    items: function items() {
      this.normalizeParams();
      this.display(this);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(6);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(1);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29880e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(11);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29880e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueSimpleNotify_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099aa838_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSimpleNotify_vue__ = __webpack_require__(10);
function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueSimpleNotify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099aa838_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSimpleNotify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"id":"vue-simple-notify","name":"veh-list","tag":"div"}},_vm._l((_vm.notifications),function(notification){return _c('div',{key:notification.index},[_c('div',{staticClass:"veh-notify",style:({ color: notification.color })},[(notification.dismissable)?_c('div',{staticClass:"veh-dismissable",on:{"click":function($event){_vm.dismiss(notification.index)}}},[_vm._v("✕\n      ")]):_vm._e(),_vm._v(" "),_c('p',[_c('span',{staticClass:"veh-type"},[_vm._v(_vm._s(notification.type)+":")]),_vm._v(" "),_c('span',{staticClass:"veh-message"},[_vm._v(_vm._s(notification.message))])])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-simple-notify',{attrs:{"delay":600,"items":_vm.notifications},on:{"onDismiss":_vm.onDismiss}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.04cceb81ba6432105a45.js